import { ACTION_TYPES } from '../../constants/store.constants';

const initialState = {
  abridgeConsentDetails: {
    status: null,
    mceEnabled: true
  }
};

const AbridgeReducer = (state, { type, payload } = {}) => {
  if (!state) state = initialState;
  if (type === ACTION_TYPES.SET_PATIENT_ABRIDGE_CONSENT) {
    return {
      ...state,
      abridgeConsentDetails: payload?.abridgeConsentDetails || initialState.abridgeConsentDetails
    };
  }
  return state;
};

export default AbridgeReducer;
